module.exports = __webpack_public_path__ + "static/media/ElectionMapSocial.0b28d29f.jpg";